import { TARGET_PLACEHOLDER, emoteAction } from "./table.ts";

/**
 * The sentence composer (ADR-114 decisions 3.1 to 3.3). The map server composes an action's text from its own copy of
 * the table and a name it already holds; the wheel's footer shows the same text before it is sent.
 */

/**
 * The text of an action as it is relayed, the part after the sender's name: the general sentence when no one is
 * named, and the targeted one with the name where `TARGET_PLACEHOLDER` stands. The name is written exactly as given
 * and once: braces, the placeholder itself or a replacement pattern inside it are plain characters.
 *
 * @param id The action's id.
 * @param targetName The target's name as the caller holds it, or null for no target.
 * @returns The sentence.
 * @throws RangeError when no action has the id; a caller checks an id from the wire against the table first.
 * @example
 * actionText(22, "Mira");
 * // "threatens Mira."
 * actionText(22, null);
 * // "threatens everyone nearby."
 */
export function actionText(id: number, targetName: string | null): string {
  const action = emoteAction(id);
  if (action === undefined) {
    throw new RangeError(`no emote action has the id ${id}`);
  }
  if (targetName === null) {
    return action.general;
  }
  const at = action.targeted.indexOf(TARGET_PLACEHOLDER);
  return action.targeted.slice(0, at) + targetName + action.targeted.slice(at + TARGET_PLACEHOLDER.length);
}
